import { render, staticRenderFns } from "./RecipeRecordTab.vue?vue&type=template&id=55223bb4&scoped=true"
import script from "./RecipeRecordTab.vue?vue&type=script&lang=js"
export * from "./RecipeRecordTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55223bb4",
  null
  
)

export default component.exports